import { render, staticRenderFns } from "./URLInstaller.vue?vue&type=template&id=5920e963&scoped=true&"
import script from "./URLInstaller.vue?vue&type=script&lang=js&"
export * from "./URLInstaller.vue?vue&type=script&lang=js&"
import style0 from "./URLInstaller.vue?vue&type=style&index=0&id=5920e963&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5920e963",
  null
  
)

export default component.exports